import type { NavigationItemType } from "../../root/layout/SidebarMenuItem";
import type { Paths } from "../../shared/usePrivacyNavigate";
import { DataImportPage } from "./DataImportPage";

export const route: NavigationItemType["route"] = { path: "data-import", element: <DataImportPage /> };
export const to = (paths: Paths) => paths.dataImport();
